import {
  ROOT_FONT_ID,
  StoreFontEnum,
  getSingleFontPreviewCssString,
  useDesignContext,
} from '@systemeio/digital-store-shared'
import { FormSelect } from '@systemeio/ui'
import React, { ReactNode, useMemo } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

export function StoreFontPicker() {
  const { t } = useLocoTranslation()
  const { state, setState } = useDesignContext()

  const fontsData: Array<{ id: StoreFontEnum; caption: string; customCaption: ReactNode }> =
    useMemo(
      () =>
        Object.entries(StoreFontEnum).map(([caption, id]) => {
          const customCaption = <span style={{ fontFamily: id }}>{caption}</span>

          const fontPreviewStyle = document.createElement('style')
          const previewId = `${ROOT_FONT_ID}-${id}`

          fontPreviewStyle.id = previewId

          const existingFontStyle = document.getElementById(previewId)
          if (existingFontStyle) {
            existingFontStyle.remove()
          }

          const fontPreviewCss = getSingleFontPreviewCssString({ fontFamily: id })

          fontPreviewStyle.append(fontPreviewCss)
          document.head.append(fontPreviewStyle)
          return { id, caption, customCaption }
        }),
      [],
    )

  return (
    <div className={'flex items-center gap-3'}>
      <FormSelect
        withoutCloseIcon
        label={t('dashboard.store.theme.primary_font')}
        containerClassName={'w-fit'}
        className={'w-44 lg:min-w-0'}
        optionsClassName="z-50"
        data={fontsData}
        value={state.primaryFont}
        onChange={data => data && setState(prev => ({ ...prev, primaryFont: data }))}
      />
      <FormSelect
        withoutCloseIcon
        label={t('dashboard.store.theme.secondary_font')}
        className={'w-44 lg:min-w-0'}
        optionsClassName="z-50"
        data={fontsData}
        value={state.secondaryFont}
        onChange={data => data && setState(prev => ({ ...prev, secondaryFont: data }))}
      />
    </div>
  )
}
